
import { defineComponent } from 'vue';
import { FooterOptions } from '@/constants';

export default defineComponent({
  name: 'Home',
  emits: ['getAuthCode'],
  data() {
    return {
      footerOptions: FooterOptions
    };
  },
  computed: {
    bkgId(): any {
      return this.$store.getters.getBackgroundID;
    }
  },
  methods: {
    login() {
      this.$emit('getAuthCode');
    },
    requestAccess() {
      this.$store.commit('showDialogAlert', {
        text: 'Access to VISTA can be requested via AccessIT.  Please follow this link for further instructions: <a href="https://basf-eu.enable-now.cloud.sap/pub/BASF18/index.html?show=group!GR_D97364F0818BF0BE#project!PR_125CFEE43EC143E6A3A62229ED63E0B5" target="_blank">LINK</a>.',
        header: 'Request access',
        icon: null
      });
    },
    currentTheme(): string {
      return require('@/assets/logo-' + this.$store.state.colorTheme + '.svg');
    },
    sessionExpired() {
      this.$store.commit('showDialogAlert', {
        text: 'Your session has expired due to your inactivity. No worry, simply login again.',
        header: 'Your session has expired',
        icon: null
      });
    }
  }
});
